import React from 'react';
import type { ButtonV2Props } from '@withjoy/joykit';
import { StyledSuccessGuestButton } from './SuccessGuestButton.styles';

interface Props extends Omit<ButtonV2Props, 'intent' | 'fill'> {
  intent?: 'primary' | 'secondary';
  fill?: boolean;
  color?: 'string';
}

export const SuccessGuestButton: React.FC<Props> = ({ fill, intent, children, ...restProps }) => {
  return (
    <StyledSuccessGuestButton
      typographyVariant="body3"
      $intent={intent}
      fullWidth={fill}
      {...restProps}
    >
      {children}
    </StyledSuccessGuestButton>
  );
};
